import { KeyValue } from "./types";

type QueryString = {
  [key: string]:
    | string
    | number
    | boolean
    | KeyValue
    | (string | number | boolean | KeyValue)[];
};

export const queryString = (params: QueryString = {}): string => {
  // get array of key value pairs ([[k1, v1], [k2, v2]])
  const qs = Object.entries(params)
    // filter pairs with undefined value
    .filter(([_, value]) => value !== undefined)
    // encode keys and values, remove the value if it is null, but leave the key
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .filter((el) => el !== null)
          .map((el) => {
            if (typeof el !== "object") {
              return `${key}=${encodeURIComponent(el)}`;
            }
            return `${key}=${encodeURIComponent(el.id)}`;
          })
          .join("&");
      }
      return [value]
        .filter((el) => el !== null)
        .map((el: string | number | boolean | KeyValue) => {
          if (typeof el !== "object") {
            return `${key}=${encodeURIComponent(el)}`;
          }
          return `${key}=${encodeURIComponent(el.id)}`;
        })
        .join("=");
    })
    .join("&");
  return qs && `?${qs}`;
};
